import { createSelector } from 'reselect';
import { appState } from './utils';
import { isDocumentUploadWidget } from './widget';
import { getDocuments as getMerchantDocuments } from './merchant/common';
const documentUploadState = createSelector(appState, (state) => state.documentUpload);
export const getStakeholdersWithUploadedDocuments = createSelector(documentUploadState, (state) => {
    return (state === null || state === void 0 ? void 0 : state.stakeholders) || [];
});
export const getDocuments = createSelector(getStakeholdersWithUploadedDocuments, getMerchantDocuments, isDocumentUploadWidget, (stakeholders, merchantDocuments, isDocumentUploadWidget) => {
    if (isDocumentUploadWidget) {
        return stakeholders.reduce((total, { documents = [] }) => [...total, ...documents], []);
    }
    return merchantDocuments;
});
export const getDocumentsOfType = (type) => createSelector(getDocuments, (documents = []) => documents.filter(doc => doc.type === type));
export const shouldCollectDocuments = createSelector(getStakeholdersWithUploadedDocuments, stakeholders => stakeholders.some(({ documentRequirements = [] }) => documentRequirements.some(d => d.required)));
export const hasLoadedDocumentTokenOnce = createSelector(documentUploadState, state => state === null || state === void 0 ? void 0 : state.loadedOnce);
